import Vue from 'vue';
import axios from "axios";
import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

const state = () => ({
    loadingData: false,
    transactionTypes: [],
});

const setQueryParams = (params, queryParams) => {
    if (params && params.search_type) {
        queryParams.push(`search_type=${params.search_type}`);
    }
    if (params && params.transaction_type_ids) {
        queryParams.push(`transaction_type_ids=${params.transaction_type_ids}`);
    }
    if (params && params.search) {
        queryParams.push(`search=${params.search}`);
    }
    if (params && params.archive === 0 || params.archive === 1) {
        queryParams.push(`archive=${params.archive}`);
    }
    if (params && params.type === 0 || params.type === 1 || params.type === 2) {
        queryParams.push(`type=${params.type}`);
    }
    if (params && params.page) {
        queryParams.push(`page=${params.page}`);
    }
};

const actions = {
    async createReason({ rootState }, reasonData) {
        const token = rootState.authToken;
        const bodyData = serialize(reasonData);

        const url = addAuthKey(`${api_url}/?r=api/reason-handbook/create`, token);
        const { data } = await axios.post(url, bodyData);

        if (data.success) {

            Vue.notify({
                group: "success-message",
                data: {
                    textMessage: `Причина для операций с личным счётом <b>${data.model.title}</b> успешно добавлена`,
                },
            });
        }

        return data;
    },
    async deleteReason({ rootState }, reasonId) {
        const token = rootState.authToken;

        const url = addAuthKey(`${api_url}/?r=api/reason-handbook/delete&id=${reasonId}`, token);
        const { data } = await axios.delete(url);

        return data;
    },
    async fetchAllReasons({ commit, state, rootState }, params) {
        if (state.loadingData) {
            return {};
        }
        commit("enableLoading");

        const token = rootState.authToken;  

        const queryParams = [];
        setQueryParams(params, queryParams);

        const { data } = await axios.get(addAuthKey(`${api_url}/?r=api/reason-handbook/index&${queryParams.join("&")}`, token));
        commit("disableLoading");

        return data;
    },
    async fetchTransactionTypes({ commit, state, rootState }) {
        if (state.loadingData) {
            return {};
        }
        commit("enableLoading");

        const token = rootState.authToken;

        const { data } = await axios.get(addAuthKey(`${api_url}?r=api/transaction-type/type-filter&types=1,2,0`, token));

        commit("disableLoading");

        commit("setTransactionTypes", data);
    },
    async updateReason({ rootState }, reasonData) {
        const token = rootState.authToken;
        const bodyData = serialize(reasonData);

        const url = addAuthKey(`${api_url}/?r=api/reason-handbook/update&id=${reasonData.id}`, token);
        const { data } = await axios.put(url, bodyData);

        if (data.success) {
            Vue.notify({
                group: "success-message",
                data: {
                    textMessage: `Причина для операций с личным счётом <b>${data.model.title}</b> успешно изменена`,
                },
            });
        }

        return data;
    },
    async updateSort({ rootState }, sortingData) {
        const token = rootState.authToken;
        const bodyData = JSON.stringify(sortingData);

        const url = addAuthKey(`${api_url}/?r=api/reason-handbook/update-sort`, token);
        const { data } = await axios.put(url, bodyData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return data;
    },
    async moveToArchive({ rootState }, reasonId) {
        const { authToken: token } = rootState;

        const { data } = await axios.get(
            addAuthKey(`${api_url}/?r=api/reason-handbook/archive&id=${reasonId}`, token),
        );

        return data;
    },
    async removeFromArchive({ rootState }, reasonId) {
        const { authToken: token } = rootState;

        const { data } = await axios.get(
            addAuthKey(`${api_url}/?r=api/reason-handbook/unarchive&id=${reasonId}`, token),
        );

        return data;
    },
};

const mutations = {
    enableLoading: (state) => {
        state.loadingData = true;
    },
    disableLoading: (state) => {
        state.loadingData = false;
    },
    setTransactionTypes(state, transactionTypes) {
        state.transactionTypes = transactionTypes;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
